'use strict';

const Mn = require('backbone.marionette');
const GroupRoleListView = require('balus/ui/view/body/role-dashboard/nav/group-role-list');
const ProjectRoleListView = require('balus/ui/view/body/role-dashboard/nav/project-role-list');
const GroupRoleRepository = require('common/domain/repository/group-role');
const ProjectRoleRepository = require('common/domain/repository/project-role');
const NavWidthChanger = require('balus/ui/view/nav-width-changer');
const Template = require('balus/ui/template/body/role-dashboard/nav/index.hbs');

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        groupRoleList: '.group-role-list-wrapper',
        projectRoleList: '.project-role-list-wrapper',
        widthChanger: '#nav-width-changer-wrapper'
    },

    onRender: function() {
        this.showChildView('widthChanger', new NavWidthChanger());
        GroupRoleRepository.find(this.model).fetchRoles()
            .then(groupRoles => {
                this.showChildView('groupRoleList', new GroupRoleListView({
                    model: this.model,
                    collection: groupRoles,
                    groupRole: this.getOption('groupRole'),
                    user: this.getOption('user')
                }));
            });

        ProjectRoleRepository.find(this.model).fetchRoles()
            .then(projectRoles => {
                this.showChildView('projectRoleList', new ProjectRoleListView({
                    model: this.model,
                    collection: projectRoles,
                    projectRole: this.getOption('projectRole'),
                    user: this.getOption('user')
                }));
            });
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/role-dashboard/nav/index.js